import type { FC } from 'react';

import { useHeaderSlice } from '../../../../store/slices/header/selectors';
import { useModifiers } from '../../../../styles/hooks/useModifiers';
import { NavPagesConnected } from '../../navPages/NavPagesConnected';
import { NavDrawerHomeSlideConnected } from '../navDrawerHomeSlide/NavDrawerHomeSlideConnected';

import drawerSliderStyles from './drawerSlider.module.css';

// unless there appears a requirement to slide between any number of arbitrary slides
// two hardcoded components for a navdrawer to create the sliding effect is sufficient
export const DrawerSliderConnected: FC<{ disableAnimation?: boolean }> = ({ disableAnimation = false }) => {
  const navRouteLevel = useHeaderSlice.getNavRouteLevel();
  const isSubNavRouteLevel = navRouteLevel >= 2;
  const drawerSliderMods = useModifiers(drawerSliderStyles, 'drawerSlider', {
    sliding: isSubNavRouteLevel,
    disableAnimation,
  });

  return (
    <div className={drawerSliderMods}>
      <div className={drawerSliderStyles.home}>
        <NavDrawerHomeSlideConnected />
      </div>
      <div className={drawerSliderStyles.navPage}>
        <NavPagesConnected />
      </div>
    </div>
  );
};
